import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, UrlTree } from '@angular/router';
import { AuthService } from '../../authentication/auth.service';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { identityUrl, staticDomains } from 'src/app/shared/constants';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private authService: AuthService,
    private localStorageService: LocalStorageService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkLoggedInRedirect(next, state);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkLoggedInRedirect(next, state);
  }
  checkLoggedInRedirect(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isAuthenticated = this.authService.isAuthenticated();
    if (isAuthenticated) {
      return isAuthenticated;
    } else {
      const url = window.location.href.replace(window.location.origin, '');
      const isLoggedInObservable = this.authService.isUserLoggedIn();
      isLoggedInObservable.subscribe((loggedin) => {
        if (!loggedin) {
          this.localStorageService.clearLocalStogareByKey('isUserLoggedOut');
          if (this.checkDomain()) {
            if(window != window.parent) {
              this.setCookie(state.url, environment.identityUrl.includes('vplaybook.com') ? 'localhost' : '.vplaybook.com');
            }
            this.router.navigate(['account/login'], { queryParams: { redirect: state.url }, replaceUrl: true });
          } else {
            this.redirectSSOLoginPage(url);
          }
        } else {
          // TODO: patch change it to return true
          this.router.navigateByUrl(url);
        }
        return loggedin;
      });
    }
  }

  checkDomain() {
    return staticDomains.includes(window.location.hostname);
  }

  redirectSSOLoginPage(url) {
    window.location.href = `${identityUrl}/sso/handlesubdomain?subdomain=${window.location.hostname.split('.')[0]}&relayState=${url}`;
  }

  setCookie(redirectUrl, domain) {
    document.cookie = 'iframeUrl = ' + redirectUrl + '; domain=.vplaybook.com; path=/; secure; samesite=none';
  }

}
